import { isEqual as lodashIsEqual } from 'lodash';

export const isEqual: <T>(
  a: T | null | undefined,
  b: T | null | undefined
) => boolean = lodashIsEqual;
